module.exports = __webpack_public_path__ + "static/media/maxim2.ffaecb62.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/maxim2.png
// module id = 760
// module chunks = 0